import { SearchandiserConfig, TrackerConfig } from '../searchandiser';
import { ProductTransformer } from '../utils/product-transformer';
import * as GbTracker from 'gb-tracker-client';
import { Events, FluxCapacitor } from 'groupby-api';
import * as Cookies from 'js-cookie';
import * as uuid from 'node-uuid';

export const MAX_COOKIE_AGE = 365; // days
export const VISITOR_COOKIE_KEY = 'visitor';
export const SESSION_COOKIE_KEY = 'session';

export class Tracker {

  _config: TrackerConfig;
  tracker: TrackerClient;
  transformer: ProductTransformer;

  constructor(private flux: FluxCapacitor, private config: SearchandiserConfig) {
    this._config = this.config.tracker || {};
    this.tracker = new GbTracker(this.config.customerId, this.config.area);
    this.transformer = new ProductTransformer(this.config.structure || {});
  }

  init() {
    this.setVisitorInfo();

    this.listenForViewProduct();
  }

  setVisitorInfo() {
    const visitorId = this._config.visitorId
      || Cookies.get(VISITOR_COOKIE_KEY)
      || uuid.v1();
    const sessionId = this._config.sessionId
      || Cookies.get(SESSION_COOKIE_KEY)
      || uuid.v1();

    this.setVisitor(visitorId, sessionId);
  }

  listenForViewProduct() {
    this.flux.on(Events.DETAILS, ({ allMeta }) => {
      const productMeta = this.transformer.transform(allMeta);
      this.tracker.sendViewProductEvent({
        product: {
          productId: productMeta().id,
          title: productMeta().title,
          price: productMeta().price,
          category: 'NONE'
        }
      });
    });
  }

  setVisitor(visitorId: string, sessionId: string) {
    this.tracker.setVisitor(visitorId, sessionId);

    Cookies.set(VISITOR_COOKIE_KEY, visitorId, { expires: MAX_COOKIE_AGE });
    Cookies.set(SESSION_COOKIE_KEY, sessionId);
  }

  search() {
    this.sendSearchEvent();
  }

  didYouMean() {
    this.sendSearchEvent('dym');
  }

  sayt() {
    this.sendSearchEvent('sayt');
  }

  addToCart(productsInfo: any) {
    this.tracker.sendAddToCartEvent(productsInfo);
  }

  order(productsInfo: any) {
    this.tracker.sendOrderEvent(productsInfo);
  }

  sendSearchEvent(origin: string = 'search') {
    this.tracker.sendSearchEvent({
      search: Object.assign({
        origin: { [origin]: true },
        query: this.flux.results.originalQuery || ''
      }, this.flux.results)
    });
  }
}



/** WEBPACK FOOTER **
 ** ./~/source-map-loader!./src/services/tracker.ts
 **/